import { TFunction } from 'i18next';

export default function getFieldName({
  field,
  cell,
  t,
}: {
  field: string;
  cell?: string;
  t: TFunction<'translation', undefined>;
}) {
  let fieldName: string;
  const cellStr = cell ? cell.toUpperCase() : '';
  switch (field) {
    case 'site.name':
      fieldName = `${t('site-name')} (${cellStr})`;
      break;
    case 'site.code':
      fieldName = `${t('site-code')} (${cellStr})`;
      break;
    case 'site.description':
      fieldName = `${t('site-description')} (${cellStr})`;
      break;
    case 'site.pointLat':
    case 'site.locationPoint.geojson.features.0.geometry.coordinates.1':
      fieldName = `${t('gps-coordinates-latitude')} (${cellStr})`;
      break;
    case 'site.pointLon':
    case 'site.locationPoint.geojson.features.0.geometry.coordinates.0':
      fieldName = `${t('gps-coordinates-longitude')} (${cellStr})`;
      break;
    case 'site.sector':
    case 'site.sectorName':
      fieldName = `${t('site-sector')} (${cellStr})`;
      break;
    case 'site.phoneNumber.countryCode':
      fieldName = `${t('phone-number-country-code')} (${cellStr})`;
      break;
    case 'site.phoneNumber.number':
      fieldName = `${t('site-phone-number')} (${cellStr})`;
      break;
    case 'site.email':
      fieldName = `${t('site-email')} (${cellStr})`;
      break;
    case 'site.userFullName':
      fieldName = `${t('responsible-person')} (${cellStr})`;
      break;
    case 'site.address.string':
      fieldName = `${t('site-address')} (${cellStr})`;
      break;
    case 'site.address.lat':
      fieldName = `${t('gps-coordinates-latitude')} (${cellStr})`;
      break;
    case 'site.address.lon':
      fieldName = `${t('gps-coordinates-longitude')} (${cellStr})`;
      break;
    case 'asset.siteName':
      fieldName = `${t('site-name')} (${cellStr})`;
      break;
    case 'asset.siteAreaName':
      fieldName = `${t('site-area')} (${cellStr})`;
      break;
    case 'asset.code':
      fieldName = `${t('asset-code')} (${cellStr})`;
      break;
    case 'asset.area':
      fieldName = `${t('area')} (${cellStr})`;
      break;
    case 'asset.categoryName':
      fieldName = `${t('category')} (${cellStr})`;
      break;
    case 'asset.serviceDate':
      fieldName = `${t('date-put-into-service')} (${cellStr})`;
      break;
    case 'asset.serialNumber':
      fieldName = `${t('serial-number')} (${cellStr})`;
      break;
    case 'asset.model':
      fieldName = `${t('model')} (${cellStr})`;
      break;
    case 'asset.description':
      fieldName = `${t('description')} (${cellStr})`;
      break;
    case 'site_area.name':
      fieldName = `${t('area-name')} (${cellStr})`;
      break;
    case 'site_area.code':
      fieldName = `${t('area-code')} (${cellStr})`;
      break;
    case 'site_area.address':
      fieldName = `${t('area-address')} (${cellStr})`;
      break;
    case 'site_area.description':
      fieldName = `${t('area-description')} (${cellStr})`;
      break;
    case 'site_area.siteName':
      fieldName = `${t('site-name')} (${cellStr})`;
      break;
    default:
      fieldName = '';
  }
  return fieldName;
}
